export default __webpack_public_path__ + "static/media/highway-Today.ba8da8d7.jpg";